import { atom } from "jotai";
import i18next from "i18next";
import { atomWithStorage } from "jotai/utils";

export const languageAtom = atomWithStorage("language", localStorage.getItem("language"));
